import type { ApplicationFlowOutcomeId } from './applicationFlowConfig'
import type { ResolvedApplicationFlowAction } from './useApplicationFlowResolver'

type ApplicationFlowOutcomeHandlers = Partial<Record<ApplicationFlowOutcomeId, () => void>>

export function executeApplicationFlowOutcome(
    outcome: ApplicationFlowOutcomeId,
    handlers: ApplicationFlowOutcomeHandlers,
): boolean {
    const handler = handlers[outcome]

    if (!handler) {
        return false
    }

    handler()
    return true
}

export function executeResolvedApplicationFlowActionOutcome(
    action: ResolvedApplicationFlowAction | undefined,
    handlers: ApplicationFlowOutcomeHandlers,
): boolean {
    if (!action?.enabled || !action.transition) {
        return false
    }

    if (action.transition.target.kind !== 'outcome') {
        return false
    }

    return executeApplicationFlowOutcome(action.transition.target.outcome, handlers)
}

export type { ApplicationFlowOutcomeHandlers }
